import { CommonModule } from '@angular/common';
import { Component, input, InputSignal } from '@angular/core';

type IconSize = 'extrasmall' | 'small' | 'medium' | 'normal' | 'large' | 'extralarge' | 'custom' | 'menu';

@Component({
    selector: 'app-icon',
    imports: [CommonModule],
    templateUrl: './icon.component.html',
})
export class IconComponent {
    public icon: InputSignal<string> = input.required();
    public size: InputSignal<IconSize> = input<IconSize>('normal');
    public bold: InputSignal<boolean> = input(false);
}
